import SkapaProductIdentifier, {
  type ProductIdentifierProps,
} from "@ingka/product-identifier";

/**
 * Display a product identifier (article number)
 * Takes a string and separates it into groups of three characters separated
 * by dots (ie. 12345678 becomes 123.456.78)
 */
export const ProductIdentifier = (props: ProductIdentifierProps) => (
  <SkapaProductIdentifier prefix="saleslead__" {...props} />
);
